import Vue from 'vue';
import Vuex, {
  createNamespacedHelpers,
  mapGetters as vuexMapGetters,
  mapActions as vuexMapActions,
} from 'vuex';
// import createLogger from 'vuex/dist/logger';

import { Store, RootGetters, RootActions, RootMutations } from './type';

import animations from './modules/animations';
import base from './modules/base';
import dimensions from './modules/dimensions';
import encyclopedia from './modules/encyclopedia';
import exhausted from './modules/exhausted';
import drag from './modules/drag';
import global from './modules/global';
import history from './modules/history';
import mix from './modules/mix';
import music from './modules/music';
import library from './modules/library';
import progress from './modules/progress';
import search from './modules/search';
import settings from './modules/settings';
import stats from './modules/stats';
import tutorials from './modules/tutorials';
import ui from './modules/ui';
import workspace from './modules/workspace';
import workspaceInactive from './modules/workspace-inactive';

Vue.use(Vuex);

const modules = {
  animations,
  base,
  dimensions,
  encyclopedia,
  exhausted,
  drag,
  global,
  history,
  mix,
  music,
  library,
  progress,
  search,
  settings,
  stats,
  tutorials,
  ui,
  workspace,
  workspaceInactive,
};


const store = new Vuex.Store({
  // @ts-ignore
  modules,
  // plugins: [createLogger()],

  strict: __DEV__,
});

export const storeHelpers =
  createNamespacedHelpers<{}, RootGetters, RootMutations, RootActions>();

export const mapGetters = vuexMapGetters as typeof storeHelpers['mapGetters'];
export const mapActions = vuexMapActions as typeof storeHelpers['mapActions'];

export default store as any as Store;
